export default "__VITE_ASSET__hDz4WhS___"